import * as yup from "yup"

export const mapValidationSchema = yup.object().shape({ 
    link_map: yup.string().label("Address").optional()
})